/**
 * LogoutApi - Logs out user via backend
 * Calls /verascore/logout endpoint which clears session cookies
 */

import PostApi from "./PostApi";

const API_BASE = import.meta.env.VITE_API_URL || '/api';

function LogoutApi(
  onSuccess: (data: any) => void,
  onFail: (data: any) => void,
  onReject: (response: string) => void
) {
  const payload = {};
  return PostApi(
    `${API_BASE}/verascore/logout`,
    payload,
    onSuccess,
    onFail,
    onReject
  );
}

export default LogoutApi;

